

function splitOnFirst(s, c) { if (!s) return [s]; var pos = s.indexOf(c); return pos >= 0 ? [s.substring(0, pos), s.substring(pos + 1)] : [s]; }

function splitOnLast(s, c) { if (!s) return [s]; var pos = s.lastIndexOf(c); return pos >= 0 ? [s.substring(0, pos), s.substring(pos + 1)] : [s]; }

function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function pad(str, length) {
    while (str.length < length) {
        str = '0' + str;
    }
    return str;
}

function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

function deserializeQueryString(queryString) {
    var result = {},
        match,
        pl = /\+/g,  // Regex for replacing addition symbol with a space
        search = /([^&=]+)=?([^&]*)/g,
        decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
        query = queryString.substring(queryString.indexOf('?') + 1, queryString.length);
    result.$$query = query;
    while (match = search.exec(query))
        result[decode(match[1])] = decode(match[2]);
    return result;
}

function removeFromArray(arr) {
    var what, a = arguments, L = a.length, ax;
    while (L > 1 && arr.length) {
        what = a[--L];
        while ((ax = arr.indexOf(what)) !== -1) {
            arr.splice(ax, 1);
        }
    }
    return arr;
}

Array.prototype.remove = function () {
    var what, a = arguments, L = a.length, ax;
    while (L && this.length) {
        what = a[--L];
        while ((ax = this.indexOf(what)) !== -1) {
            this.splice(ax, 1);
        }
    }
    return this;
};

const ssUtil = {
    chunk: function (arr, size) {
        var newArr = [];
        if (arr && arr.length) {
            for (var i = 0; i < arr.length; i += size) {
                newArr.push(arr.slice(i, i + size));
            }
        }
        return newArr;
    },
    capitalize: capitalize,
    pad: pad,
    splitOnFirst: splitOnFirst,
    splitOnLast: splitOnLast,
    validateEmail: validateEmail,
    deserializeQueryString: deserializeQueryString,
    removeFromArray
}

export default ssUtil;